export default [
  {
    header: 'IntraOP',
    icon: 'GridIcon',
    route: 'intra-op',
    title: 'IntraOP'
  },
]
